import { Controller } from "@hotwired/stimulus";
import { turboRequest } from "../helpers/api";

export default class AnalyticsFilterController extends Controller {
  range() {
    return this.update({ range: this.element.value });
  }

  chart() {
    const filters = this.element.closest("[data-analytics-filters]");
    return this.update({
      status: filters.querySelector("[name=\"status\"]").value,
      year: filters.querySelector("[name=\"year\"]").value,
    });
  }

  update(params) {
    const url = new URL(this.element.dataset.url, globalThis.location.origin);
    for (const [key, value] of Object.entries(params)) url.searchParams.set(key, value);
    return turboRequest(url, { method: "GET", turboStream: true });
  }
}
